/**
 * Component is used to show cart summary options on the cart page
 *
 * @attr {string} [cssModifier] - Css class for cart summary gift option
 * @attr {string} [priceLabel] - price label
 * @param {Array}  [giftOptions] - Array of cart summary options
 * @param {String} [giftOptionTitle] - label used for order summary gift when has no elements inside and showing total price 0
 *
 * HTML Structure Example
 * <e2-cart-summary-gift-options></e2-cart-summary-gift-options>
 *
 */

import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { selectors } from '@elab/core/store/cart';
import { priceFormatter } from '@elab/core/utils/PriceUtils';

export class CartSummaryGiftOptions extends SimpleLitElement {
    static get properties() {
        return {
            cssModifier: { type: String, attribute: 'css-modifier' },
            priceLabel: { type: String, attribute: 'price-label' },
            giftOptions: { type: Array, attribute: false },
            optionsTotalPrice: { type: Object, attribute: false },
            giftOptionTitle: { type: String, attribute: 'gift-option-title' },
        };
    }

    constructor() {
        super();
        this.cssModifier = '';
        this.giftOptions = [];
        this.optionsTotalPrice = {};
        this.giftOptionTitle = '';
        this.priceLabel = '';
    }

    renderQuantity(quantity) {
        return quantity && quantity > 1
            ? html`
                  <div class="cart-summary__gift-option-quantity"><span>X</span>${quantity}</div>
              `
            : null;
    }

    getGiftOption = ({ giftOptionType, optionTotalPrice }) => {
        const { value, currencyIso } = optionTotalPrice;
        const price = priceFormatter(value, currencyIso);

        return html`
            <div class="cart-summary__row cart-summary__gift-option ${this.cssModifier}">
                <div class="cart-summary__gift-option-title-container">
                    <div class="cart-summary__gift-option-title">
                        ${giftOptionType || this.giftOptionTitle}
                    </div>
                </div>
                <e2-price-badge
                    price-label="${this.priceLabel}"
                    additional-class="formatted-price__label-plus"
                    class="cart-summary__price"
                    price="${price}"
                ></e2-price-badge>
            </div>
        `;
    };

    render() {
        return html`
            <div class="cart-summary__gift-options">
                ${this.giftOptions.length > 0
                    ? this.giftOptions.map(this.getGiftOption)
                    : this.getGiftOption({
                          optionTotalPrice: this.optionsTotalPrice,
                      })}
            </div>
        `;
    }
}

const mapStateToProps = state => {
    const giftOptionsTotal = selectors.getCartSummaryGiftOptions(state);

    return {
        giftOptions: giftOptionsTotal.giftOptionTotals || [],
        optionsTotalPrice: giftOptionsTotal.optionsTotalPrice || {},
    };
};

export default () =>
    customElements.define(
        'e2-cart-summary-gift-options',
        connect(mapStateToProps)(CartSummaryGiftOptions),
    );
